<template>
    <div>
        <div v-if="panel_required">
            <div class="designeroption" :data-designer-component-id="component_id">
                <h3>{{ title }}</h3>
                <div class="stylesoption">
                    <div class="row">
                        <div class="col">
                            <designer-question-glass-colour :fabricator="fabricator"
                                                            title="Outer Border"
                                                            v-model:target="localPrimaryColour"
                                                            :slab="slab"
                                                            :glass-design="glassDesign"></designer-question-glass-colour>
                        </div>
                        <div class="col">
                            <designer-question-glass-colour :fabricator="fabricator"
                                                            title="Inner Border"
                                                            v-model:target="localSecondaryColour"
                                                            :slab="slab"
                                                            :glass-design="glassDesign"
                                                            :primary-colour="primaryColour"></designer-question-glass-colour>
                        </div>
                    </div>
                    <div class="stylesoption pt-0 pb-0">
                        NB: Glass colours are not visualised.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    export default {
        props: {
            title: {
                default(){
                    return 'Glass Colour';
                }
            },
            component_id: {
                default(){
                    return 'glass_colour';
                }
            },
            fabricator: {
                required: true,
            },
            glassDesign: {
                required: true,
            },
            slab: {
                required: true,
            },
            primaryColour: {
                required: false,
                default() {
                    return '';
                }
            },
            secondaryColour: {
                required: false,
                default() {
                    return '';
                }
            },
            target: {
                default() {
                    return '';
                }
            }
        },
        data(){
            return {
                options: {
                    has_colour_option: false,
                },
                fetchData: _.debounce(function() {
                    window.axios.post('/api/get-glass-colour-option', {
                        slab: this.slab,
                        glass_design: this.glassDesign,
                        primary_colour: this.primaryColour,
                        secondary_colour: this.secondaryColour,
                        fabricator: this.fabricator,
                    })
                    .then((response) => {
                        this.options = response.data;
                        this.localTarget = response.data.glass_type_config_id;
                    })
                    .then(() => {
                        //
                    });
                }, 750)
            }
        },
        computed: {
            localTarget: {
                get() {
                    return this.target
                },
                set(val) {
                    if(this.target !== val) {
                        this.$emit('update:target', val)
                    }
                }
            },
            localPrimaryColour: {
                get() {
                    return this.primaryColour
                },
                set(val) {
                    if(this.primaryColour !== val) {
                        this.$emit('update:primary-colour', val)
                    }
                }
            },
            localSecondaryColour: {
                get() {
                    return this.secondaryColour
                },
                set(val) {
                    if(this.secondaryColour !== val) {
                        this.$emit('update:secondary-colour', val)
                    }
                }
            },
            passed_filter(){
                return this.variable_ready(this.glassDesign, this.slab);
            },
            cache_key(){
                return '_' + this.glassDesign + '_' + this.slab + '_' + this.primaryColour + '_' + this.secondaryColour + '_' + this.fabricator;
            },
            panel_required(){
                return this.options.has_colour_option != false;
            },
        },
        watch: {
            'cache_key': function (val, oldVal) {
                this.fetchData();
            },
        },
        mounted(){
            this.fetchData();
        },
    }
</script>
